// useCallApi.ts
import { useEffect } from 'react'
import { callApi } from '../services/callApi'

export const useCallApi = () => {
  useEffect(() => {
    // Cleanup on unmount only - don't auto-refresh on mount
    return () => {
      callApi.destroy().catch(console.error)
    }
  }, [])

  return callApi
}
